import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
  OPCalendarCreateRequestDTO, 
  OPCalendarUpdateRequestDTO, 
  OPCalendarDeleteRequestDTO, 
  OPCalendarReadByCompanyIdRequestDTO, 
  OPCalendarGetMonthlyCalendarByCompanyRequestDTO, 
  OPCalendarDTO, 
  OPCalendarListDTO 
} from './calendar.interface';
import { OPCalendar_create, OPCalendar_delete, OPCalendar_getMonthlyCalendarByCompany, OPCalendar_readAll, OPCalendar_readByCompanyID, OPCalendar_update } from 'src/app/GlobalVariable';


@Injectable({
  providedIn: 'root'
})
export class OPCalendarService {
  constructor(private http: HttpClient) {}

  OPCalendar_readAll(): Observable<OPCalendarListDTO > {
    return this.http.get<OPCalendarListDTO >(OPCalendar_readAll);
  }

  OPCalendar_readByCompanyId(data: OPCalendarReadByCompanyIdRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_readByCompanyID, data);
  }

  OPCalendar_getMonthlyCalendarByCompany(data: OPCalendarGetMonthlyCalendarByCompanyRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_getMonthlyCalendarByCompany, data);
  }

  OPCalendar_create(data: OPCalendarCreateRequestDTO): Observable<OPCalendarDTO> { 
    return this.http.post<OPCalendarDTO>(OPCalendar_create, data);
  }

  OPCalendar_update(data: OPCalendarUpdateRequestDTO): Observable<OPCalendarDTO> {
    return this.http.post<OPCalendarDTO>(OPCalendar_update, data);
  }

  OPCalendar_delete(data: OPCalendarDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(OPCalendar_delete, data);
  }
}
